var _defs, _rect, _g, _text, _text2, _text3, _text4, _line, _text5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutreachBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    width: 400,
    height: 400,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1a1a2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2d2d44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "num",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fbbf24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f59e0b"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "url(#bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "rgba(255,255,255,0.04)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 100,
    x2: 400,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 200,
    x2: 400,
    y2: 200
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 300,
    x2: 400,
    y2: 300
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 0,
    x2: 100,
    y2: 400
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 0,
    x2: 200,
    y2: 400
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 0,
    x2: 300,
    y2: 400
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 80,
    fontFamily: "'Inter', sans-serif",
    fontSize: 13,
    fontWeight: 600,
    letterSpacing: 3,
    fill: "rgba(255,255,255,0.55)"
  }, "\n    OUTREACH BOT\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 240,
    fontFamily: "'Poppins', 'Inter', sans-serif",
    fontSize: 160,
    fontWeight: 800,
    letterSpacing: -6,
    fill: "url(#num)"
  }, "\n    80%\n  ")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 290,
    fontFamily: "'Inter', sans-serif",
    fontSize: 20,
    fontWeight: 500,
    fill: "#fff"
  }, "\n    of cold emailing,\n  ")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 320,
    fontFamily: "'Inter', sans-serif",
    fontSize: 20,
    fontWeight: 500,
    fill: "#fff"
  }, "\n    automated.\n  ")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 350,
    x2: 360,
    y2: 350,
    stroke: "rgba(255,255,255,0.12)",
    strokeWidth: 1
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 375,
    fontFamily: "'Inter', sans-serif",
    fontSize: 11,
    fontWeight: 500,
    letterSpacing: 2,
    fill: "rgba(255,255,255,0.5)"
  }, "\n    MEDIUM \xB7 9 MIN READ\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutreachBot);
export default __webpack_public_path__ + "static/media/OutreachBot.d084637009625efe4a5d6531af79117a.svg";
export { ForwardRef as ReactComponent };